import React, { useCallback } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { appendMetadataWithIndex } from 'ml-portals-util-react';

import metadata from './MLPartnerCarrierChoicesComponent.metadata.json5';
import styles from './MLPartnerCarrierChoicesComponent.module.scss';

const MLPartnerCarrierChoicesComponent = (props) => {
    const {
        option,
        lob,
        optionLobIndex,
        pendingChoices,
        jobNumber,
        updatePendingChoices
    } = props;

    const { refreshData } = useDataRefresh();
    const translator = useTranslator();

    const getOptionValue = useCallback((choice) => {
        return `${option.jobStatus.code}_${lob.code}_${choice.code}`
    }, [lob.code, option.jobStatus.code]);

    const updateSelection = useCallback((choice) => {
        const selectionKey = `${option.jobStatus.code}_${lob.code}_${choice.code}`;
        const selection = {
            agentChoice: choice.code,
            lob: lob.code,
            status: option.jobStatus.code,
            jobNumber: jobNumber
        };
        if (pendingChoices.has(selectionKey)) {
            pendingChoices.delete(selectionKey);
            _.set(choice, 'selected', false);
        } else {
            pendingChoices.set(selectionKey, selection);
            _.set(choice, 'selected', true);
        }
        updatePendingChoices(new Map(pendingChoices));
        refreshData();
    }, [jobNumber, lob.code, option.jobStatus.code, pendingChoices, refreshData, updatePendingChoices]);

    const choicesOverrides = useCallback(() => {
        const choiceOverride = lob.choices.map((choice, choiceIndex) => {

            return {
                [`choice${optionLobIndex}${choiceIndex}`]: {
                    id: getOptionValue(choice),
                    onValueChange: () => updateSelection(choice),
                    label: translator({
                        id: choice.name,
                        defaultMessage: choice.name
                    }),
                    value: choice.selected
                }
            }
        });

        return Object.assign({}, ...choiceOverride);
    }, [getOptionValue, lob.choices, optionLobIndex, translator, updateSelection])

    const overrides = {
        [`choicesIterable${optionLobIndex}`]: {
            data: lob.choices
        },
        ...choicesOverrides()
    }

    const resolvers = {
        resolveClassNameMap: styles
    };

    const updatedMetadata = appendMetadataWithIndex(metadata.componentContent, optionLobIndex);
    return <MetadataContent uiProps={updatedMetadata} overrideProps={overrides} {...resolvers} />;
};

MLPartnerCarrierChoicesComponent.propTypes = {
    optionLobIndex: PropTypes.number.isRequired,
    option: PropTypes.shape({}).isRequired,
    pendingChoices: PropTypes.shape({}).isRequired,
    jobNumber: PropTypes.string.isRequired,
    lob: PropTypes.shape({}).isRequired,
    updatePendingChoices: PropTypes.func.isRequired
};

export default MLPartnerCarrierChoicesComponent;
